"use client";

import { ComponentInfo } from "@builder.io/sdk-react";

export const PRODUCT_TEASER_CAROUSEL_INPUTS = [
  {
    name: "items",
    type: "list",
    hideFromUI: true,
    subFields: [
      { name: "urlKey", type: "string" },
      { name: "urlSuffix", type: "string" },
      { name: "type", type: "string" },
      { name: "name", type: "string" },
      { name: "sku", type: "string" },
      { name: "imageLabel", type: "string" },
      { name: "imageSrc", type: "string" },
      { name: "shortDescription", type: "string" },
    ],
  },
  { name: "title", type: "string", required: true },
  { name: "redirectHref", type: "url", required: true },
  { name: "redirectLabel", type: "string", required: true },
  { name: "buyNowLabel", type: "string" },
  { name: "discoverLabel", type: "string" },
  { name: "tryNowLabel", type: "string" },
  { name: "discoverPageLink", type: "string" },
  { name: "hideBuyCta", type: "boolean" },
  { name: "hidePrice", type: "boolean" },
  { name: "customBadgeDark", type: "boolean" },
  { name: "hideCustomBadge", type: "boolean" },
  { name: "hideDescription", type: "boolean" },
  { name: "hideDiscountBadge", type: "boolean" },
  { name: "hideDiscoverButton", type: "boolean" },
  { name: "hidePriceInformation", type: "boolean" },
  { name: "hideRightBadge", type: "boolean" },
  { name: "hideStrikethroughPrice", type: "boolean" },
  { name: "rightBadgeDark", type: "boolean" },
] as const satisfies ComponentInfo["inputs"];

export type ProductTeaserCarouselProps = BuilderComponentProps<
  typeof PRODUCT_TEASER_CAROUSEL_INPUTS
>;
